import request from 'helpers/request';
import { AppVersionType } from './types';
import { APP_VERSION_URL } from 'constants/api';

export const postAppVersion = (appVersion: AppVersionType): Promise<string> =>
    request.post(`${APP_VERSION_URL}`, appVersion);
